<template>
  <div class="c-list-box">
    <ul class="c-list-nav">
      <li class="c-list-title">个人养老金扣除</li>
      <el-button
        type="primary"
        :icon="Download"
        link
        @click="state.showAgent = true"
        v-if="$judge_auth('29')"
      >
        从税局更新数据
      </el-button>
      <el-button
        type="warning"
        link
        icon="Tickets"
        @click.stop="state.showLog = true"
        v-if="$judge_auth('30')"
      >
        操作记录
      </el-button>
    </ul>
    <ul class="c-list-search">
      <el-date-picker
        v-model="state.params.skssq"
        type="month"
        placeholder="税款所属月份"
        value-format="YYYYMM"
        format="YYYY年M月"
        :clearable="false"
        style="width: 140px"
      />
      <div
        class="c-withholdingagent-search-box"
        @click="state.showWithholdingAgent = true"
      >
        <li style="flex: 1; display: flex; column-gap: 5px">
          <template v-if="state.withholding_agent_arr?.length > 0">
            <div
              class="c-withholdingagent-search-tag"
              style="
                max-width: 200px;
                overflow: hidden;
                text-overflow: ellipsis;
              "
            >
              {{ state.withholding_agent_arr[0]?.name }}
            </div>
            <el-popover
              v-if="state.withholding_agent_arr?.length > 1"
              placement="right"
              width="auto"
              popper-style="max-height: 90vh;overflow-y: auto;"
            >
              <template #reference>
                <div class="c-withholdingagent-search-tag" @click.stop="">
                  {{ "+ " + (state.withholding_agent_arr?.length - 1) }}
                </div>
              </template>
              <template #default>
                <div
                  style="
                    display: flex;
                    flex-direction: column;
                    row-gap: 5px;
                    width: fit-content;
                  "
                >
                  <ul
                    v-for="(item, index) in state.withholding_agent_arr"
                    :key="item"
                    style="
                      white-space: nowrap;
                      background-color: #f0f2f5;
                      color: var(--el-color-info);
                      border-radius: 4px;
                      font-size: 12px;
                      padding: 0 9px;
                      height: 24px;
                      line-height: 24px;
                      display: flex;
                      align-items: center;
                      column-gap: 10px;
                    "
                  >
                    <li>{{ item.name }}</li>
                    <el-icon
                      @click.stop="state.withholding_agent_arr.splice(index, 1)"
                      color="#a2a2a2"
                      style="cursor: pointer"
                      ><CircleClose
                    /></el-icon>
                  </ul>
                </div>
              </template>
            </el-popover>
          </template>
          <text v-else style="color: #a2a2a2">点击选择扣缴义务人</text>
        </li>
        <el-icon
          v-if="state.withholding_agent_arr?.length > 0"
          @click.stop="delete state.withholding_agent_arr"
          color="#a2a2a2"
          ><CircleClose
        /></el-icon>
      </div>
      <el-select
        v-model="state.params.tax_bureau_id"
        placeholder="税局"
        style="width: 300px"
      >
        <el-option
          v-for="item in state.customerData"
          :key="item.id"
          :label="item.name"
          :value="item.id"
        />
        <template #footer>
          <el-button size="small" @click="onLoadCustomer()"> 刷新 </el-button>
        </template>
      </el-select>
      <el-select
        v-model="state.params.customer_id"
        placeholder="所属客户"
        style="width: 300px"
      >
        <el-option
          v-for="item in state.customerData"
          :key="item.id"
          :label="item.alias + '(' + item.name + ')'"
          :value="item.id"
        />
        <template #footer>
          <el-button size="small" @click="onLoadCustomer()"> 刷新 </el-button>
        </template>
      </el-select>
      <el-input
        v-model="state.params.keywords"
        style="width: 200px"
        placeholder="姓名、证件号、手机号"
        clearable
        @clear="
          delete state.params.keywords;
          onLoad();
        "
        @paste.enter="$onKeywordsPaste($event, state.params)"
      ></el-input>
      <el-dropdown split-button @click="onLoad" type="primary">
        查询
        <template #dropdown>
          <el-dropdown-menu>
            <el-dropdown-item :icon="RefreshLeft" @click="onReset()">
              重置
            </el-dropdown-item>
          </el-dropdown-menu>
        </template>
      </el-dropdown>
    </ul>
    <ul class="c-list-table">
      <el-table
        ref="tableDom"
        :data="state.tableData"
        v-loading="!Array.isArray(state.tableData)"
        element-loading-background="rgba(0, 0, 0, 0.2)"
        :default-sort="{
          prop: state.params.sort_field,
          order: state.params.sort_value == 'desc' ? 'descending' : 'ascending',
        }"
        @sort-change="onSortChange"
        @row-click="onRowClick"
      >
        <el-table-column type="selection" width="55" fixed />
        <el-table-column
          fixed
          label="序号"
          width="50"
          type="index"
          :index="
            (index) => (state.params.page - 1) * state.params.limit + index + 1
          "
          align="center"
        />
        <el-table-column
          prop="xm"
          label="姓名"
          width="120"
          :formatter="$tab_TextFormat"
          fixed
        />
        <el-table-column
          prop="zzhm"
          label="证件号"
          :formatter="$tab_TextFormat"
          width="180"
        >
          <template #default="{ row }">
            <text
              style="color: #1e90ff"
              class="text-hover-decoration"
              title="证件号"
              @click="$onCopy(row.zzhm)"
            >
              {{ row.zzhm }}
            </text>
          </template>
        </el-table-column>
        <el-table-column
          prop="update_time"
          label="更新时间"
          :formatter="$tab_TextFormat"
          width="180"
        />
        <el-table-column
          prop="withholding_agent_name"
          label="扣缴义务人"
          :formatter="$tab_ShowToolTip"
          min-width="160"
        />
        <el-table-column
          prop="unified_social_credit_identifier"
          label="统一社会信用代码"
          :formatter="$tab_TextFormat"
          width="180"
        >
          <template #default="{ row }">
            <text
              style="color: #1e90ff"
              class="text-hover-decoration"
              title="统一社会信用代码"
              @click="$onCopy(row.unified_social_credit_identifier)"
            >
              {{ row.unified_social_credit_identifier }}
            </text>
          </template>
        </el-table-column>
        <el-table-column
          prop="tax_bureau_name"
          label="税局"
          :formatter="$tab_ShowToolTip"
          min-width="220"
        />
        <el-table-column
          prop="jcje"
          label="本次缴存金额"
          :formatter="$tab_MoneyFormat"
          width="160"
        />
        <el-table-column prop="ljgrylj" label="累计个人养老金" width="160">
          <template #default="{ row }">
            <c_money
              :value="row.ljgrylj"
              style="color: #ffa500; font-weight: 600"
            ></c_money>
          </template>
        </el-table-column>
        <el-table-column
          label="操作"
          width="120"
          align="center"
          fixed="right"
          v-if="$judge_auth('31')"
        >
          <template #default="{ row }">
            <el-button
              type="danger"
              link
              icon="Delete"
              @click.stop="onDelete(row.id)"
            >
              删除
            </el-button>
          </template>
        </el-table-column>
      </el-table>
      <c_page
        :total="state.totalCount"
        :pageIndex="state.params.page"
        :pageSize="state.params.limit"
        @onLoad="
          (page) => {
            state.params.page = page.pageIndex;
            state.params.limit = page.pageSize;
            onLoad();
          }
        "
      />
    </ul>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showAgent"
        title="从税局更新个人养老金"
        @close="state.showAgent = false"
      >
        <c_Agent
          v-if="state.showAgent"
          :skssq="state.params.skssq"
          @close="state.showAgent = false"
          @confirm="onSelectConfirm"
        ></c_Agent>
      </c_popup>
    </transition>
    <el-drawer v-model="state.showLog" title="操作记录" size="70%">
      <c_PersonalPensionLog></c_PersonalPensionLog>
    </el-drawer>
    <transition name="el-zoom-in-center">
      <c_popup
        v-if="state.showWithholdingAgent"
        title="选择扣缴义务人"
        @close="state.showWithholdingAgent = false"
      >
        <c_WithholdingAgentSelect
          @close="
            (arr) => {
              state.withholding_agent_arr = arr;
              state.showWithholdingAgent = false;
            }
          "
          :selectItems="state.withholding_agent_arr"
        ></c_WithholdingAgentSelect>
      </c_popup>
    </transition>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import {
  data_withholdingagent_select,
  data_customer_select,
  data_taxbureau_select,
} from "@/http/data";
import {
  personalpension_list,
  personalpension_del,
} from "@/http/personalpension";
import { confirm_func } from "@/utils/qFormat";
import { dayjs } from "element-plus";
import c_Agent from "./SelectWithholdingAgent.vue";

class InitFormData {
  params = {
    limit: 20,
    page: 1,
  };
}
export default {
  components: {
    c_Agent,
  },
  setup() {
    const tableDom = ref(null);
    const state = reactive(new InitFormData());
    onMounted(() => {
      state.params.skssq = dayjs().subtract(1, "month").format("YYYYMM");

      onLoadWithholdingAgent();
      onLoadCustomer();
      onLoadTaxBureau();
      onLoad();
    });

    const onLoad = () => {
      delete state.tableData;

      if (state.withholding_agent_arr?.length > 0)
        state.params.withholding_agent_id = state.withholding_agent_arr
          ?.map((m) => m.id)
          .join(",");
      else delete state.params.withholding_agent_id;

      personalpension_list(state.params).then((res) => {
        if (res.status == 200) {
          const { count, list } = res.data.data;
          state.tableData = list;
          state.totalCount = count;
        }
      });
    };

    //获取客户
    const onLoadCustomer = () => {
      data_customer_select().then((res) => {
        if (res.status == 200) state.customerData = res.data.data?.list;
      });
    };

    //加载扣缴义务人
    const onLoadWithholdingAgent = () => {
      data_withholdingagent_select().then((res) => {
        if (res.status == 200)
          state.withholding_agent_data = res.data.data?.list;
      });
    };

    //加载税局
    const onLoadTaxBureau = () => {
      data_taxbureau_select().then((res) => {
        if (res.status == 200) state.taxbureau_data = res.data.data?.list;
      });
    };

    //排序
    const onSortChange = ({ column }) => {
      if (column.order) {
        state.params.sort_field = column.sortable;
        state.params.sort_value = column.order === "ascending" ? "asc" : "desc";
      } else {
        const params = new InitFormData().params;
        state.params.sort_field = params.Order;
        state.params.sort_value = "asc";
      }
      onLoad();
    };

    //重置查询条件
    const onReset = () => {
      Object.assign(state, new InitFormData());
      onLoad();
    };

    //表格行点击事件
    const onRowClick = (row) => {
      tableDom.value.toggleRowSelection(row);
    };

    //删除
    const onDelete = (id) => {
      confirm_func(personalpension_del, id, onLoad);
    };

    //从税局更新数据确认事件
    const onSelectConfirm = () => {
      state.showAgent = false;
      onLoad();
    };

    return {
      state,
      tableDom,
      onLoad,
      onSortChange,
      onReset,
      onLoadCustomer,
      onLoadWithholdingAgent,
      onLoadTaxBureau,
      onRowClick,
      onDelete,
      onSelectConfirm,
    };
  },
};
</script>
<style scoped></style>
